// extracted by mini-css-extract-plugin
module.exports = {"status":"OrderStatus_status__10e41","statusRaw":"OrderStatus_statusRaw__a5hG0","statusBooked":"OrderStatus_statusBooked__3PJuf","statusUnknown":"OrderStatus_statusUnknown__382Rk"};